import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { SnackbarProvider } from 'notistack'

ReactDOM.createRoot(document.getElementById('root')).render(

  <SnackbarProvider autoHideDuration={5000} maxSnack={4}>
      <App />
  </SnackbarProvider>

)

reportWebVitals()
